import React from "react";
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { BaasicModal } from "core/components";
import { PatientTemplateCustomOrderingDoctorChangeModal } from "application/niko-patient/components";

function PatientTemplateCustomOrderingDoctorAddTemplate({ patientTemplateCustomOrderingDoctorAddViewStore, disabled }) {
    const {
        patientTemplate,
        updateCustomOrderingDoctorData,
        patientTemplateCustomOrderingDoctorChangeModal,
        openPatientTemplateCustomOrderingDoctorChangeModal,
        isClinicalInfoModal
    } = patientTemplateCustomOrderingDoctorAddViewStore;

    const handleDropDownItemsOnClick = async (e) => {
        if (e.item.text === "Change Doctor") {
            updateCustomOrderingDoctorData("change-doctor");
        }
        else if (e.item.text === "Remove Doctor") {
            updateCustomOrderingDoctorData("remove-doctor");
        }
    }

    return (
        <React.Fragment>
            <DropDownButton
                fillMode={"solid"}
                themeColor={"primary"}
                onItemClick={(e) => handleDropDownItemsOnClick(e)}
                buttonClass={`btn btn--sml btn--light btn--dd doctor ${patientTemplate.customOrderingDoctorId || patientTemplate.isOrderingDoctorRemoved ? 'has-triangle' : ''}`}
                disabled={disabled}
                popupSettings={!isClinicalInfoModal ? {
                    animate: false,
                    anchorAlign: { horizontal: "right", vertical: "bottom" },
                    popupAlign: { horizontal: "right", vertical: "top" },
                } : {}}
                itemRender={(props) => {
                    const { item } = props;
                    if (item.text === "Change Doctor") {
                        return (
                            <div className="u-flex--default">
                                <button
                                    onClick={() => updateCustomOrderingDoctorData("change-doctor")}
                                     className="dd-button u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--change2--grey u-icon--sml" />
                                </button>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                    }
                    if (item.text === "Doctor Changed") {
                        return (
                            <div className="u-flex--default"
                                onClick={() => openPatientTemplateCustomOrderingDoctorChangeModal()}
                            >
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        updateCustomOrderingDoctorData("undo-change-doctor");
                                    }}
                                    className="dd-button is-undo u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--xmed u-icon--undo--grey" />
                                </button>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                    } else if (item.text === "Remove Doctor") {
                        return (
                            <div className="u-flex--default">
                                <React.Fragment>
                                    <div className="u-icon u-icon--xmed u-icon--delete--grey"  style={{ marginRight: '7px', paddingLeft: '4px' }}/>
                                </React.Fragment>
                                <span className="item-text">{item.text}</span>
                            </div>
                        );
                    }
                    else if (item.text === "Doctor Removed") {
                        return (
                            <div className="u-flex--default">
                                <button
                                    onClick={() => updateCustomOrderingDoctorData("undo-remove-doctor")}
                                    className="dd-button is-undo u-mar--right--sml"
                                >
                                    <span className="u-icon u-icon--xmed u-icon--undo--grey" />
                                </button>
                                <span className="item-text" style={{cursor: 'default'}}>{item.text}</span>
                            </div>
                        );
                    }

                    return <span>{item.text}</span>;
                }}
            >
                {!patientTemplate.customOrderingDoctorId && !patientTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Change Doctor" />
                )}

                {patientTemplate.customOrderingDoctorId && !patientTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Doctor Changed" />
                )}

                {!patientTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Remove Doctor" />
                )}

                {patientTemplate.isOrderingDoctorRemoved && (
                    <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Doctor Removed" />
                )}

            </DropDownButton>
            <BaasicModal modalParams={patientTemplateCustomOrderingDoctorChangeModal} className="modal__content modal--med">
                <PatientTemplateCustomOrderingDoctorChangeModal />
            </BaasicModal>
        </React.Fragment>
    )
}

PatientTemplateCustomOrderingDoctorAddTemplate.propTypes = {
    patientTemplateCustomOrderingDoctorAddViewStore: PropTypes.object,
    item: PropTypes.object,
    disabled: PropTypes.bool
};

export default defaultTemplate(PatientTemplateCustomOrderingDoctorAddTemplate);